import { render, staticRenderFns } from "./LoginVue.vue?vue&type=template&id=3b52c74b"
import script from "./LoginVue.vue?vue&type=script&lang=js"
export * from "./LoginVue.vue?vue&type=script&lang=js"
import style0 from "./LoginVue.vue?vue&type=style&index=0&id=3b52c74b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports